import { styled } from '@mui/material/styles';

export const StyledLabel = styled('div')({
    position: "absolute",
    left: 0,
    top: 0,
    padding: "0 5px",
    display: "block",
    transformOrigin: "top left",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    transform: "translate(10px, -9px) scale(0.75)",
    zIndex: 1,
    color: "rgba(0, 0, 0, 0.6)",
    backgroundColor: "#fff",
    cursor: "auto"
}); 